import { Theme, styled } from '@material-ui/core';

const Wrapper = styled('div')<Theme>(({ theme }) => ({
  marginTop: theme.spacing(3),
  paddingTop: theme.spacing(3),
  borderTop: theme.config.defaultBorder(theme.palette.grey['200']),
}));

export default Wrapper;
